// extracted by mini-css-extract-plugin
module.exports = {"EditoAlternateTextImage":"styles_EditoAlternateTextImage__1L3Kc","content":"styles_content__1u5N_","item":"styles_item__PT8Mz"};